import { render } from "./time-slot.component.vue?vue&type=template&id=4f554f5a&ts=true"
import script from "./time-slot.component.vue?vue&type=script&lang=ts"
export * from "./time-slot.component.vue?vue&type=script&lang=ts"

import "./time-slot.component.vue?vue&type=style&index=0&id=4f554f5a&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__